"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../"); // Update the import path
/**
 * Styled component for the horizontal scroll container.
 */
var HorizontalScrollContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  overflow-x: scroll;\n  white-space: nowrap;\n  cursor: grab;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  display: flex;\n  overflow-x: scroll;\n  white-space: nowrap;\n  cursor: grab;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])));
/**
 * The FlatList component.
 * Fetches data from the provided path and renders it as a horizontally scrolling list.
 *
 * @param {FlatListProps} props The props passed to the FlatList component.
 * @returns {JSX.Element} The rendered horizontal list.
 */
var FlatList = function (_a) {
    var path = _a.path, Component = _a.Component, select = _a.select, Empty = _a.Empty, filter = _a.filter, noAuth = _a.noAuth;
    /**
     * Custom hook useEloise assumed to provide logic for fetching and updating data.
     */
    var logic = (0, __1.useEloise)().logic;
    /**
     * State to hold the fetched data.
     */
    var _b = (0, react_1.useState)(), data = _b[0], setData = _b[1];
    /**
     * Reference to the scrolling container.
     */
    var scrollRef = (0, react_1.useRef)(null);
    /**
     * Fetch data on component mount and set it to the state.
     */
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var fetchedData, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!noAuth) return [3 /*break*/, 2];
                        return [4 /*yield*/, logic.fb.docs.getCollection(path)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, logic.fb.docs.getUserCollection(path)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        fetchedData = _a;
                        setData(fetchedData);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [path, logic.fb]);
    /**
     * Function to update data. Assumes logic in useEloise for updating data.
     *
     * @param {any} data The data to update.
     * @returns {Promise<any | false>} The updated data or false if the update was not successful.
     */
    var update = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, logic.fb.docs.setUserDoc(path, data)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result ? data : false];
            }
        });
    }); };
    /**
     * Effect to handle the horizontal scrolling behavior when the user scrolls vertically.
     */
    (0, react_1.useEffect)(function () {
        var handleWheel = function (event) {
            if (scrollRef.current) {
                scrollRef.current.scrollLeft += event.deltaY;
            }
        };
        var scrollElement = scrollRef.current;
        if (scrollElement) {
            scrollElement.addEventListener("wheel", handleWheel);
        }
        return function () {
            if (scrollElement) {
                scrollElement.removeEventListener("wheel", handleWheel);
            }
        };
    }, []);
    /**
     * Render the horizontal list.
     */
    if (!data) {
        return react_1.default.createElement(__1.Loading, null);
    }
    var filteredDocs = filter ? data.filter(filter) : data;
    if (filteredDocs && filteredDocs.length === 0 && Empty) {
        return react_1.default.createElement(Empty, null);
    }
    return (react_1.default.createElement(HorizontalScrollContainer, { ref: scrollRef }, filteredDocs &&
        filteredDocs.map(function (item, index) { return (react_1.default.createElement("div", { key: index, style: { display: "inline-block" } },
            react_1.default.createElement(Component, { data: item, update: update, select: select }))); })));
};
exports.default = FlatList;
var templateObject_1;
